/** A hunk header, e.g. `@@ -12,7 +12,9 @@ fun thing()`. The trailing section name is optional. */
const DIFF_HUNK = /^@@ -\d+(?:,\d+)? \+\d+(?:,\d+)? @@/;

/**
 * Whether an unlabelled fenced block is a unified diff.
 *
 * The test is a hunk header and nothing weaker. Plenty of ordinary listings start lines with `-` — a shell
 * transcript full of flags, a YAML list, a changelog of dashes — and colouring those as deletions would be
 * worse than showing a real diff plain. A `@@ -a,b +c,d @@` line does not occur by accident.
 *
 * Kept in step with the phone's copy of this rule, so the same patch doesn't read as a diff on one surface
 * and as a listing on the other.
 */
export function looksLikeDiff(text: string): boolean {
  return text.split("\n").some((line) => DIFF_HUNK.test(line));
}

/**
 * The language to highlight a fence as: what the author labelled it, or `diff` when they labelled it nothing
 * and it reads as one. A label is a statement about the block and is never second-guessed.
 */
export function fenceLanguage(lang: string | undefined, text: string): string | undefined {
  if (lang) return lang;
  return looksLikeDiff(text) ? "diff" : undefined;
}
